(function($, angular, window) {
    'use strict';

})(jQuery, angular, window);
window.THF.Angular.LiveQuoteTool.directive('thfFieldRadio', ['$sce', function($sce) {
    var link = function(scope, el) {
        scope.icons = {
            radialDefault: { src: window.THF.SiteSettings.svgSprite+'#ui-radial-default', viewBox: '0 0 32 32.01' },
            radialChecked: { src: window.THF.SiteSettings.svgSprite+'#ui-radial-filled', viewBox: '0 0 32 32.01' },
        };
        scope.isValid = function(validationArray, key, type) {
            if( typeof validationArray === 'undefined' ) {
                return true;
            }

            if( typeof validationArray[key] === 'undefined' ) {
                return true;
            }



            if(typeof type !== 'undefined' && typeof validationArray[key].details !== 'undefined') {

                if(validationArray[key].details instanceof Array) {
                    var validationDetails = validationArray[key].details.filter(function(item) {
                        return item.type === type;
                    });
                    if(validationDetails.length > 0) {
                        var detail = validationDetails[0];

                        return detail.result;
                    }
                }

                return false;
            }
            else {
                return validationArray[key].result;
            }


            return true;
        };

        scope.labelIdentifier = uuidv4();
        function uuidv4() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
                return v.toString(16);
            });
        }
    };
    return {
        'restrict': 'E',
        'replace': true,
        'scope': {
            'field': '=',
            'validation': '=',
            'model': '=',
            'focus': '&',
            'blur': '&'
        },
        'link': link,
        'templateUrl': function() {
            return THF.Utility.Location.cacheBustUrl('/static/views/live-quote-tool/fields/radio.html');
        }
    };
}]);
